// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { CmApi, CmSgApi, CmSignupApi } from "_Route/Api";


const AdCustomerDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const curType = params.id === 'add' ? '등록' : '수정';
  const curScore = params.id === 'add' ? 200 : 300;
  const useGroup = ['미사용', '사용'];

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  const [info, setInfo] = useState({
    cust_uuid: undefined,
    cust_email: '',
    cust_pass: curType === '등록' ? '' : undefined,
    cust_name: '',
    cust_corp: '',
    cust_tel: '',
    cust_use: 1,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { cust_email, cust_pass, cust_name, cust_corp, cust_tel, cust_use} = info;
  const [rePass, setRePass] = useState('');
  const [successChk, setSuccessChk] = useState('');

  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * Set Current cust List
  ========================================================================*/
  useEffect(() => {
    axios.get(CmSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        cust_uuid: params.id
      }
    })
    .then(res => {
      const curCm = res.data.result[0]
      if(curCm === undefined && params.id !== 'add') {
        navigate('/404');
      }
      else {
        if (curType === '수정') {
          Object.entries(curCm).map(key => {
            if(Object.keys(info).includes(key[0])) {
              info[key[0]] = key[1]
            }
          })
          setInfo({...info})
        }
      }
    })
    .catch(err => {
      console.error(err, "GET Customer Data Error...");
    })
  }, [location])


  /*========================================================================
  * Check Input Data
  ========================================================================*/
  const regExpEmail = () => {
    const regExp = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
    return regExp.test(cust_email);
  }

  const regExpTel = () => {
    const regExp = /^\d{3}\d{3,4}\d{4}$/;
    return regExp.test(cust_tel);
  }

  const CmConfirm = () => {
    if(Object.values(info).includes('') || (curType === '등록' && cust_pass !== rePass) || !regExpEmail() || !regExpTel()) {
      setSuccessChk(false)
    }
    else {
      if (curType === '수정') { updateCM() }
      else { postCM() }
    }
  }


  /*========================================================================
  * Cusomer Axios 
  ========================================================================*/
  const postCM = () => { // Customer 등록
    axios({
      url: CmSignupApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`고객 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/customer-mgt/list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `Customer POST Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const updateCM = () => { // Customer 수정
    axios({
      url: CmApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`고객 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/customer-mgt/list')
    })
    .catch(err => {
      console.error(err, "Customer PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const deleteCM = () => { // Customer 삭제
    axios({
      url: CmApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        cust_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`고객 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/customer-mgt/list')
    })
    .catch(err => {
      console.error(err, "Customer DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>고객 {curType}</h2>
        <p>Home / 고객 관리 / 고객 {curType}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>고객 등록 및 수정</legend>

          {/* 사용여부 [cust_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" id={`cust_use_${i}`} onChange={() => setInfo({...info, cust_use: i})} checked={Number(cust_use) === i}/>
                  <label htmlFor={`cust_use_${i}`}></label>

                  <label htmlFor={`cust_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 업체명 [cust_corp] */}
          <div className="fieldGroup row">
            <label>업체명<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="cust_corp" onChange={(e) => onChange(e)} value={cust_corp} placeholder="업체명을 입력해주세요." />
            </div>
            {
              successChk === false && cust_corp === '' &&
              <p className="fieldTxt error"><i className="icofont-warning-alt"></i>업체명을 입력해주세요.</p>
            }
          </div>

          {/* 이름 [cust_name] */}
          <div className="fieldGroup row">
            <label>이름<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="cust_name" onChange={(e) => onChange(e)} value={cust_name} placeholder="이름을 입력해주세요." />
            </div>
            {
              successChk === false && cust_name === '' &&
              <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이름을 입력해주세요.</p>
            }
          </div>

          {/* 휴대폰 번호 [cust_tel] */}
          <div className="fieldGroup row">
            <label>휴대폰 번호<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="cust_tel" onChange={(e) => setInfo({...info, cust_tel: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')})} value={cust_tel} placeholder="휴대폰 번호를 입력해주세요." />
            </div>
            {
              successChk === '' ? 
              <p className="fieldTxt info">* 휴대폰 번호는 -(하이픈)을 제외하고 숫자만 입력해주세요.</p>
              :
                successChk === false && cust_corp === '' ?
                <p className="fieldTxt error"><i className="icofont-warning-alt"></i>휴대폰 번호를 입력해주세요.</p>
                :
                successChk === false && !regExpTel() &&
                <p className="fieldTxt error"><i className="icofont-warning-alt"></i>올바른 휴대폰 번호 형식이 아닙니다.</p>
            }
          </div>

          {/* 이메일 아이디 [cust_email] */}
          <div className="fieldGroup row">
            <label>이메일 아이디<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="cust_email" onChange={(e) => onChange(e)} value={cust_email} placeholder="이메일 아이디를 입력해주세요." disabled={curType === '등록' ? false : true} />
            </div>
            {
              successChk === false && !regExpEmail() &&
              <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이메일 형식이 올바르지 않습니다.</p>
            }
          </div>

          {
            curType === '등록' &&
            <>
              {/* 비밀번호 [cust_pass] */}
              <div className="fieldGroup row">
                <label>비밀번호<span className="redTxt">*</span></label>

                <div className="field">
                  <input type="password" className="input md round_10" name="cust_pass" onChange={(e) => onChange(e)} value={cust_pass} placeholder="비밀번호를 입력해주세요." />
                </div>
                {
                  successChk === '' ?
                  <p className="fieldTxt info">* 임시 비밀번호로, 추후 고객이 변경하여 사용합니다.</p>
                  :
                  successChk === false && cust_pass === '' &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>비밀번호를 입력해주세요.</p>
                }
              </div>

              {/* 비밀번호 확인 [cust_repass] */}
              <div className="fieldGroup row">
                <label>비밀번호 확인<span className="redTxt">*</span></label>

                <div className="field">
                  <input type="password" className="input md round_10" onChange={(e) => setRePass(e.target.value)} value={rePass} placeholder="비밀번호를 한번 더 입력해주세요." />
                </div>
                {
                  successChk === false && rePass === '' ?
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>비밀번호를 한번 더 입력해주세요.</p>
                  :
                  successChk === false && rePass !== cust_pass &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>비밀번호가 서로 일치하지 않습니다.</p>
                }
              </div>
            </>
          }

          {/* 등록/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={CmConfirm}>{curType} {master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/customer-mgt/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 고객을 삭제${master === 1 ? '' : ' 요청'}하시겠습니까?`)) deleteCM() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdCustomerDt;